import React from "react";
import { CheckIcon, ChevronRightIcon, InboxIcon } from "./icons";

const CompactProcessingItem = ({
  icon: Icon = InboxIcon,
  title,
  subtitle,
  meta,
  onClick,
}: {
  icon?: any;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  meta?: React.ReactNode;
  onClick?: () => void;
}) => {
  const clickable = typeof onClick === "function";
  const Component = (clickable ? "button" : "div") as any;

  return (
    <Component
      type={clickable ? "button" : undefined}
      onClick={onClick}
      className={`pp-actions-processing-item${clickable ? " is-clickable" : ""}`}
    >
      <span className="pp-actions-processing-check" aria-hidden="true">
        <CheckIcon />
      </span>

      <span className="pp-actions-processing-icon" aria-hidden="true">
        <Icon />
      </span>

      <span className="pp-actions-processing-copy">
        <span className="pp-actions-processing-title">{title}</span>
        {subtitle && (
          <span className="pp-actions-processing-subtitle">{subtitle}</span>
        )}
      </span>

      <span className="pp-actions-processing-right">
        {meta && <span className="pp-actions-processing-pill">{meta}</span>}
        {clickable && (
          <ChevronRightIcon
            className="pp-actions-processing-chevron"
            aria-hidden="true"
          />
        )}
      </span>
    </Component>
  );
};



export default CompactProcessingItem;
